export default __webpack_public_path__ + "static/media/play.7d5ba4d7.svg";